/** Backend capability strings for team / access admin surfaces. */
export const TeamPermissions = {
  read: 'manage_users',
  manageRoles: 'manage_roles',
  manageUsers: 'manage_users',
  manageCapabilities: 'manage_capabilities',
} as const
